import React, { createContext, useState, ReactNode } from "react";

interface Filters {
  startDate: any;
  endDate: any;
  vehicleRegistration: any;
  name: string | null;
  status: string | null;
  project: any;
}

interface FilterContextType {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
}

//get initial start and end date for current week

let start = new Date();
let end = new Date();
const currentDay = start.getDay(); // 0 (Sunday) - 6 (Saturday)
start.setDate(start.getDate() - currentDay);
end = new Date(start);
end.setDate(start.getDate() + 6); // Always ends on Saturday

export const TLFilterContext = createContext<FilterContextType | undefined>(
  undefined
);

export const TLFilterProvider = ({ children }: { children: ReactNode }) => {
  const [filters, setFilters] = useState<Filters>({
    startDate: null,
    endDate: null,
    vehicleRegistration: null,
    name: null,
    status: null,
    project: null,
  });

  return (
    <TLFilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </TLFilterContext.Provider>
  );
};
